import axios from "axios";
import { toAbsoluteUrl } from "../../_metronic/utils/utils";

export const vapidKey = process.env.VAPIDKEY; 

//export const LOGIN_URL = "api/auth/login";
export const LOGIN_URL = "token"
export const REQUEST_PASSWORD_URL = "api/auth/forgot-password";
export const ME_URL = "api/me";
export const LOC_API_URL = "https://mpe.practicemetrix.com:9994"
//start ========live url configurations
export const REGISTER_URL = "https://mpe.practicemetrix.com:9997/master/registration";
export const API_URL = "https://mpe.practicemetrix.com:9997"
export const CHAT_URL = "https://mpe.practicemetrix.com:5000";
export const PAYMENT_SOCKET_URL = "wss://mpe.practicemetrix.com:9997/paymentsocket/";
export const TOKEN_PREFIX ="mpe";
//end ==========live url configurations

//start =========uat url configurations
//export const REGISTER_URL = "https://mpe.practicemetrix.com:9998/master/registration";
//export const API_URL = "https://mpe.practicemetrix.com:9998"
//export const CHAT_URL = "https://mpe.practicemetrix.com:4000";
//export const PAYMENT_SOCKET_URL = "wss://mpe.practicemetrix.com:9998/paymentsocket/";
//export const TOKEN_PREFIX = "mpeuat";
//end =========uat url configurations

//local
//export const REGISTER_URL = "http://18.156.28.241:9997/master/registration";
//export const API_URL = "https://18.156.28.241:9998"
//export const API_URL = "http://localhost:9998"

axios.interceptors.response.use(
  response => response,
  error => {
    //console.log("api error::::",error);
    
    if(error!=null && error!= undefined && error!="Error: Network Error")
    {
      const {status} = error.response;
     // console.log("api response:::",status);
      if (status == "401") {
        //dispatch(userSignOut());
        //console.log("api response111:::",status);
        //localStorage.removeItem('access_token');
        ////if(TOKEN_PREFIX === "mpeuat")
        ////  window.location = '/mpeuat/logout';
        ////else
        ////  window.location = '/logout';
          //alert.show('SmartCH Notification  -- Your session was expired, login again.');


      }
      return Promise.reject(error);
    }
    else
    {
      //window.location = '/logout';
      //alert.show('SmartCH Notification  -- Your are not authorized to perform this action.');
    }
 }
);

//currency formating

export const USDFormat = (amount) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
  }).format(amount);

export function getChatUrl() {
  return CHAT_URL;
}


export function login_keycloak(email, password) {
  //console.log(LOGIN_URL);
  //console.log(email);
  //console.log(password);
 

  const grant_type = "password";
  const client_id="account";
  
  //const client_secret ="######"// 
  const client_secret ="#######"// 
  
  const post_data = "username=" + email + "&password="+password+ "&grant_type="+grant_type+"&client_id="+client_id+"&client_secret="+client_secret;
    return axios.post(LOGIN_URL, 
           post_data,
            {
              headers:{'Content-Type':'application/x-www-form-urlencoded'}
            }
         );
}

export function login(email, password) {
  //console.log(LOGIN_URL);
  //console.log(email);
  //console.log(password);
 


  const username = email;
  const url = `${API_URL}/profile/authenticate`;

  const post_data = "username=" + email + "&password="+password;
    return axios.post(url, 
           post_data
         );
}


export function getUsers(page,perPage,sortBy,sortKey,searchObj)
{
  const url = `${API_URL}/master/search/user?page=`+page+'&perPage='+perPage+'&sortBy='+sortBy+'&sortKey='+sortKey;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  if(searchObj===undefined) searchObj={};
  return axios.post(url, searchObj,options);
}

export function getInventories(page,perPage,sortBy,sortKey,searchObj)
{
  const url = `${API_URL}/product/inventorylist?page=`+page+'&perPage='+perPage+'&sortBy='+sortBy+'&sortKey='+sortKey;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  if(searchObj===undefined) searchObj={};
  return axios.post(url, searchObj,options);
}

export function getStates(countryCode)
{
  const url = `${LOC_API_URL}/master/searchwo/state?page=1&perPage=100&sortBy=stateName&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{countryCode});
}

export function getDistrict(stateCode)
{
  const url = `${LOC_API_URL}/master/searchwo/district?page=1&perPage=500&sortBy=districtName&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{stateCode});
}

export function getProductRequirements(id)
{
  const url = `${API_URL}/product/prodreq/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getProductRDetails(id)
{
  const url = `${API_URL}/product/prodreqdetails/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getUsersCountByAccount()
{
  const url = `${API_URL}/dashboard/usercount`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{},options);
}

export function getArea(districtCode)
{
  const url = `${LOC_API_URL}/master/searchwo/area?page=1&perPage=500&sortBy=areaName&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{districtCode});
}

export function getZip(areaCode)
{
  const url = `${LOC_API_URL}/master/searchwo/zip?page=1&perPage=50&sortBy=zipCode&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{areaCode});
}

export function getLocations(page,perPage,sortBy,sortKey,searchObj)
{
  const url = `${API_URL}/master/search/location?page=`+page+'&perPage='+perPage+'&sortBy='+sortBy+'&sortKey='+sortKey;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  if(searchObj===undefined) searchObj={};
  return axios.post(url, searchObj,options);
}


export function getUsersWoP()
{
  const url = `${API_URL}/profile/alluser`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function getMappedUsers()
{
  const url = `${API_URL}/profile/allmappeduser`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}
export function getStatusSummary(accountKey)
{
  let url = `${API_URL}/schedule/summary`;
  if(accountKey !==undefined && accountKey !==null && accountKey !== "")
    url = `${API_URL}/schedule/summary?accountKey=${accountKey}`;
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function getOrderStatusSummary(accountKey)
{
  let url = `${API_URL}/order/summary`;
  if(accountKey !==undefined && accountKey !==null && accountKey !== "")
    url = `${API_URL}/order/summary?accountKey=${accountKey}`;
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function getInventoryReport(type,reportType,postObj)
{
  let url = `${API_URL}/product/reports/inventory?type=${type}&reportType=${reportType}`;
 
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.post(url,postObj,options);
}

export function InventorySummaryExport(type,reportType,postObj)
{
  let url = `${API_URL}/product/reports/inventory/export?type=${type}&reportType=${reportType}`;
 
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.post(url,postObj,options);
}

export function getSalesInsight(type,reportType,postObj)
{
  let url = `${API_URL}/order/reports/salesinsight?type=${type}&reportType=${reportType}`;
 
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.post(url,postObj,options);
}

export function getSalesCompare(type,reportType,postObj)
{
  let url = `${API_URL}/order/reports/comparison?type=${type}&reportType=${reportType}`;
 
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.post(url,postObj,options);
}

export function getTodoUser(id)
{
  const url = `${API_URL}/schedule/statusbyuser/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}
export function getHelp()
{
  const url = `${API_URL}/profile/help`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}
export function getBanners()
{
  const url = `${API_URL}/profile/banner`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}
export function getBannersByAccount()
{
  const url = `${API_URL}/profile/mbanner`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}
export function getChatUsers(id)
{
  const url = `${API_URL}/patient/rights/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}
export function forgotPassword(email)
{
  const url = `${API_URL}/registration/forgotpassword/`+email;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.post(url);
}

export function updateUser(id,userObj)
{
  const url = `${API_URL}/master/user/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,userObj,options);
}

export function updateBannerOrder(bannerList)
{
  const url = `${API_URL}/profile/bannerorder`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,bannerList,options);
}

export function bulkUpdate(updateObj)
{
  const url = `${API_URL}/schedule/bulkupdate`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,updateObj,options);
}


export function updateNoti(id,notiObj)
{
  const url = `${API_URL}/master/notification/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,notiObj,options);
}
export function approve(id)
{
  const url = `${API_URL}/jobrequest/approve/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{},options);
}
export function reject(id)
{
  const url = `${API_URL}/jobrequest/reject/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{},options);
}
export function archive(id)
{
  const url = `${API_URL}/patient/archive/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{},options);
}
export function retrieve(id)
{
  const url = `${API_URL}/patient/retrieve/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{},options);
}
export function dpArchive(id)
{
  const url = `${API_URL}/jobrequest/archive/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{},options);
}
export function dpRetrieve(id)
{
  const url = `${API_URL}/jobrequest/retrieve/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{},options);
}
export function getTemplates()
{
  const url = `${API_URL}/template/list`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}
export function getTemplateByKey(id)
{
  const url = `${API_URL}/template/listbykey/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}

export function getTemplateDataByKey(id)
{
  const url = `${API_URL}/template/listdatabykey/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}

export function signedUrl(params)
{
  const url = `${API_URL}/file/signedurl`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.post(url,params, options);
}
export function signedUrlDP(params)
{
  const url = `${API_URL}/file/signedurldp`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.post(url,params, options);
}
export function editPs(params,id)
{
  const url = `${API_URL}/user/setp/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.post(url,params, options);
}
export function rotateFile(id)
{
  const url = `${API_URL}/file/rotate/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.post(url,{}, options);
}

export function signedUrlBanner(params)
{
  const url = `${API_URL}/file/signedurlbanner`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.post(url,params, options);
}

export function s3Upload(url,file)
{
  return axios.put(url,file);
}

export function s3UploadWithOptions(url,file,options)
{
  return axios.put(url,file,options);
}

export function getNotes(id)
{
  const url = `${API_URL}/schedule/notes/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}



export function getJobServices(id)
{
  const url = `${API_URL}/jobrequest/services/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function getJobNotes(id)
{
  const url = `${API_URL}/jobrequest/notes/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function getJobFiles(id)
{
  const url = `${API_URL}/jobrequest/files/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function getlatestSTlFiles(id)
{
  const url = `${API_URL}/jobrequest/latestStl/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}` 
  }};
  
  return axios.get(url,options);
}

export function updateMaster(master,id,mssterObj)
{
  let url = `${API_URL}/master/`+master+'/'+id+'/update';
  if(master=='user')
  {
   url = `${API_URL}/user/activate/`+id;
  }
  if(master=='schedule')
  {
   url = `${API_URL}/schedule/update/`+id;
  }
  if(master =='pentity')
  {
    url = `${API_URL}/patient/status/`+id;
  }
  if(master =='banner')
  {
    url = `${API_URL}/master/${master}/`+id;
  }
  if(master =='pentityupdate')
  {
    url = `${API_URL}/master/pentity/`+id+`/update`;
  }
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,mssterObj,options);
}

export function updateSchedule(master,id,mssterObj)
{
  let url = `${API_URL}/master/`+master+'/'+id+'/update';
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,mssterObj,options);
}

export function updateScan(id,mssterObj)
{
  let url = `${API_URL}/product/scan/update/`+id;
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,mssterObj,options);
}

export function bulkUpdateScan(updateList)
{
  let url = `${API_URL}/product/scan/bulkapprove`;
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,updateList,options);
}

export function updateJobrStatus(id,jobStatusKey)
{
  let url = `${API_URL}/jobrequest/status/`+id;
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{jobStatusKey},options);
}
export function updateOrderReqStatus(id,orderStatusKey)
{
  let url = `${API_URL}/order/status/`+id;
  
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'application/json',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,{orderStatusKey},options);
}
export function convert(file,id,name)
{
  let url = `${API_URL}/file/convert?id=`+id+'&name='+name;
  const formData = new FormData();
  formData.append('file',file)
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`,
    'Content-Type':'multipart/form-data',
    'Access-Control-Allow-Origin' :'*'

  }};

  return axios.post(url,formData,options);
}



export function getMyProfile()
{
  const url = `${API_URL}/profile/user`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}

export function getAccountDetails()
{
  const url = `${API_URL}/profile/myaccount`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}


export function getMenus()
{
  const url = `${API_URL}/profile/menu`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}

export function getPatientRights(page,postObj)
{
  if(page===undefined) page=1;
  const url = `${API_URL}/patient/list?page=`+page;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

 

  return axios.post(url,postObj, options);
}


export function getPatientRightsExport(postObj)
{
  
  const url = `${API_URL}/patient/list?page=1&export=csv`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

 

  return axios.post(url,postObj, options);
}


export function getSchedulesExport(postObj)
{
 
  const url = `${API_URL}/schedule/list?page=1&export=csv`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}

export function getInventoriesExport(postObj)
{
 
  const url = `${API_URL}/product/inventorylist?page=1&export=csv`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getDpExport(postObj)
{
 
  const url = `${API_URL}/jobrequest/list?page=1&export=csv`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getProducts(page,postObj,perPage)
{
  if(page===undefined) page=1;
  if(perPage===undefined) perPage=20;
  //console.log("Per Page  :::",perPage);
  const url = `${API_URL}/product/list?page=`+page+`&perPage=`+perPage;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getSchedules(page,postObj,perPage)
{
  if(page===undefined) page=1;
  if(perPage===undefined) perPage=20;
  //console.log("Per Page  :::",perPage);
  const url = `${API_URL}/schedule/list?page=`+page+`&perPage=`+perPage;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getJobRequests(page,postObj,perPage)
{
  if(page===undefined) page=1;
  if(perPage===undefined) perPage=20;
  //console.log("Per Page  :::",perPage);
  const url = `${API_URL}/jobrequest/list?page=`+page+`&perPage=`+perPage+`&sortBy=deliveryDate&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getOrders(page,postObj,perPage)
{
  if(page===undefined) page=1;
  if(perPage===undefined) perPage=20;
  //console.log("Per Page  :::",perPage);
  const url = `${API_URL}/order/list?page=`+page+`&perPage=`+perPage;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getSchedulesWO(page,postObj,perPage)
{
  if(page===undefined) page=1;
  if(perPage===undefined) perPage=100;
  //console.log("Per Page  :::",perPage);
  const url = `${API_URL}/schedule/listwo?page=`+page+`&perPage=`+perPage;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
    if(postObj===undefined) postObj={};

  return axios.post(url,postObj, options);
}
export function getSchedulesById(id)
{
  const url = `${API_URL}/schedule/find/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}

export function getJobById(id)
{
  const url = `${API_URL}/jobrequest/find/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};

  return axios.get(url, options);
}

//export function getCurrentUser()
//{
//const url = `${API_URL}/master/user/`;
//  return axios.get(url);
//}
export function getWidgetData()
{
  const url = `${API_URL}/dashboard/data`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getStockStatus()
{
  const url = `${API_URL}/product/reports/stockstatus`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getWidgetDataByAccount(id)
{
  const url = `${API_URL}/master/widgetdata/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getSettings(id)
{
  const url = `${API_URL}/master/settings/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getFileAnnotation(id)
{
  const url = `${API_URL}/patient/annotation/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getBusinessEntities()
{
  const url = `${API_URL}/master/entity?sortBy=businessEntity&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getBusinessEntitiesWoS()
{
  const url = `${API_URL}/master/entity`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url);
}

export function getRoles()
{
  const url = `${API_URL}/master/role?perPage=100&sortBy=roleDescription`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getScheduleByKey(id)
{
  const url = `${API_URL}/schedule/findkey/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getPatients()
{
  const url = `${API_URL}/master/pentity`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getJobSummary()
{
  const url = `${API_URL}/jobrequest/summary`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getPendingApprovals()
{
  const url = `${API_URL}/master/registration`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function approvePending(user) {

  const url = `${API_URL}/registration/approve/`+user.id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,user,options);
}

export function completeTask(sch) {

  const url = `${API_URL}/schedule/complete/`+sch.id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,sch,options);
}
export function addFile(id,fileName,originalFileSize,fileType,parentFileId) {

  const url = `${API_URL}/patient/file/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{fileName,originalFileSize,fileType,parentFileId},options);
}

export function addJobFile(id,fileName,originalFileSize,fileType,parentFileId,fileTag) {

  const url = `${API_URL}/jobrequest/file/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{fileName,originalFileSize,fileType,parentFileId,fileTag},options);
}

export function deleteFile(id) {

  const url = `${API_URL}/patient/deletefile/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{},options);
}


export function deleteJobFile(id) {

  const url = `${API_URL}/jobrequest/deletefile/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{},options);
}

export function deleteUser(id,postObj) {

  const url = `${API_URL}/user/delete/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,postObj,options);
}

export function addUserToken(fireBaseToken) {

  const url = `${API_URL}/profile/token`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{fireBaseToken},options);
}

export function getFile(id,fileKey) {

  const url = `${API_URL}/file/download/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{fileKey},options);
}

export function getRequestSummary(id) {

  const url = `${API_URL}/order/requirementsummary/${id}`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{},options);
}

export function getRequestSummaryByImplant() {

  const url = `${API_URL}/order/requirementbyimplant`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{},options);
}

export function shareFile(id,fileKey,userKey) {

  const url = `${API_URL}/file/sendFile/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{fileKey,userKey},options);
}

export function rejectPending(user) {

  const url = `${API_URL}/registration/reject/`+user.id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,options,user);
}

export function getFields()
{
  const url = `${API_URL}/master/configuration/5e900bdeb861887456e01375`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getScreenFields(screen)
{
  const url = `${API_URL}/configuration/`+screen;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getNotiCount()
{
  const url = `${API_URL}/profile/notificationcount`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getAccounts()
{
  const url = `${API_URL}/master/account?perPage=1000&sortBy=accountName`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getLabAccounts()
{
  const url = `${API_URL}/profile/labaccounts`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}




export function getAccountTypes()
{
  const url = `${API_URL}/master/accounttype?perPage=500&sortBy=displayOrder`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}


export function getJobServiceTypes()
{
  const url = `${API_URL}/master/jobservice?perPage=500&sortBy=serviceType`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getProcedureTypes()
{
  const url = `${API_URL}/master/proceduretype?perPage=500&sortBy=displayOrder`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getMyAccounts()
{
  const url = `${API_URL}/profile/accounts`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getRolesByAccount()
{
  const url = `${API_URL}/master/role?perPage=100&sortBy=roleDescription&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}
export function getStatus()
{
  const url = `${API_URL}/master/status?perPage=100&sortBy=statusName&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getJobStatus()
{
  const url = `${API_URL}/master/jobstatus?perPage=100&sortBy=jobStatusName&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getOrderStatus()
{
  const url = `${API_URL}/master/orderstatus?perPage=100&sortBy=orderNum&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getOrderDetails(id)
{
  const url = `${API_URL}/order/orderdetails/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getJobDPServices()
{
  const url = `${API_URL}/master/jobservice?perPage=100&sortBy=serviceType&sortKey=asc`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getPatientById(id)
{
  const url = `${API_URL}/master/pentity/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getPentityByKey(id)
{
  const url = `${API_URL}/patient/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function getScheduleByPatient(id)
{
  const url = `${API_URL}/schedule/patient/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);
}

export function createUser(firstName, lastName, email, mobile, roleKey,accountKey,locationKey,mobileServiceProvider,commPreference) {
  const url = `${API_URL}/user/create`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ firstName, lastName, email, mobile, roleKey,accountKey,locationKey,mobileServiceProvider,commPreference},options);
}

export function createPaymentLink(id) {
  const url = `${API_URL}/jobrequest/paymentlink/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ },options);
}

export function createOrderPaymentLink(id) {
  const url = `${API_URL}/order/paymentlink/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ },options);
}

export function createAccount(accountName,businessEntity,mappedAccounts,expiryDate,colorCode,accountTypeKey,patientIdPrefix,procedureTypes) {
  const url = `${API_URL}/master/account`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{accountName,businessEntity,mappedAccounts,expiryDate,colorCode,accountTypeKey,patientIdPrefix,procedureTypes},options);
}

export function createLocation(locationName,accountKey,address,phone,email,countryCode,countryName,stateCode,stateName,districtCode,districtName) {
  const url = `${API_URL}/master/location`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{locationName,accountKey,address,phone,email,countryCode,countryName,stateCode,stateName,districtCode,districtName},options);
}

export function createTier( accountTypeName,typeDescription,bannerDisplayTime,allocatedStorage,allocatedUsers,displayOrder) {
  const url = `${API_URL}/master/accounttype`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{accountTypeName,typeDescription,bannerDisplayTime,allocatedStorage,allocatedUsers,displayOrder},options);
}

export function createProcedure( procedureTypeName,typeDescription,displayOrder) {
  const url = `${API_URL}/master/proceduretype`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{procedureTypeName,typeDescription,displayOrder},options);
}

export function createBanner(bannerType,imagePath,message,publishTo,publishDate,expiryDate,accountKey,displayTime,displayOrder) {
  const url = `${API_URL}/master/banner`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{bannerType,imagePath,message,publishTo,publishDate,expiryDate,accountKey,displayTime,displayOrder},options);
}

export function createSupport(userKey, roleKey, accountKey,attachments,subject,description,accountName,roleName) {
  const url = `${API_URL}/master/support`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{userKey, roleKey, accountKey,attachments,subject,description,accountName,roleName},options);
}


export function editUser(id,firstName, lastName, email, mobile, roleKey,accountKey,locationKey,mobileServiceProvider,commPreference) {
  const url = `${API_URL}/user/update/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ firstName, lastName, email, mobile, roleKey,accountKey,locationKey,mobileServiceProvider,commPreference},options);
}

export function createSchedule(assignedToAccountKey, roleId, userId, scheduleType, pEntityId,startDate,endDate,notes,taskTypeId,locationKey,procedureTypeKey) {
  const url = `${API_URL}/schedule/create`;
  //const status= '#bd10e0';
  const status = 'Referred Patient';
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{assignedToAccountKey, roleId, userId, scheduleType, pEntityId,startDate,endDate,notes,taskTypeId,status,locationKey,procedureTypeKey},options);
}

export function createJobRequest(assignedToAccountKey, pEntityId,notes,jobServiceTypes,deliveryDate,locationKey,extractionTop,extractionBottom,treatmentPlans,implantTypes) {
  const url = `${API_URL}/jobrequest/create`;
  //const status= '#bd10e0';
  const status = 'Referred Patient';
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{assignedToAccountKey, pEntityId,notes,jobServiceTypes,deliveryDate,locationKey,extractionTop,extractionBottom,treatmentPlans,implantTypes},options);
}

export function updateJobRequest( jobRequestId,jobServiceTypes,deliveryDate,locationKey,extractionTop,extractionBottom,treatmentPlans,implantTypes) {
  const url = `${API_URL}/jobrequest/update/`+jobRequestId;
  //const status= '#bd10e0';
  const status = 'Referred Patient';
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{jobServiceTypes,deliveryDate,locationKey,extractionTop,extractionBottom,treatmentPlans,implantTypes},options);
}


export function createOrder(params) {
  const url = `${API_URL}/order/createorder/select`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,params,options);
}


export function createDigitalPlanner(assignedToAccountKey, roleId, userId, scheduleType, pEntityId,startDate,endDate,notes,taskTypeId,locationKey,procedureTypeKey) {
  const url = `${API_URL}/digitalplanner/create`;
  //const status= '#bd10e0';
  const status = 'Referred Patient';
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{assignedToAccountKey, roleId, userId, scheduleType, pEntityId,startDate,endDate,notes,taskTypeId,status,locationKey,procedureTypeKey},options);
}

export function changePassword(password) {
  const url = `${API_URL}/user/changepassword`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{password},options);
}

export function createTemplateData(id,templateData) {
  const url = `${API_URL}/template/create/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,templateData,options);
}

export function createRequirement(params) {
  const url = `${API_URL}/order/requirement`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,params,options);
}

export function bulkOrder(params) {
  const url = `${API_URL}/order/createorder/bulk`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,params,options);
}

export function createPatient(firstName,lastName,middleName,dateOfBirth,email,mobile,secondaryMobile,address,pinCode,city,state,country,accountKey,gender) {
  const url = `${API_URL}/patient/create`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ firstName,lastName,middleName,dateOfBirth,email,mobile,secondaryMobile,address,pinCode,city,state,country,accountKey,gender},options);
}
export function createStatus(statusId,statusName,statusDescription) {
  const url = `${API_URL}/master/status`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ statusId,statusName,statusDescription},options);
}
export function createJobStatus(jobStatusColor,jobStatusName,statusDescription) {
  const url = `${API_URL}/master/jobstatus`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ jobStatusColor,jobStatusName,statusDescription},options);
}
export function createOrderStatus(orderStatusColor,orderStatusName,statusDescription) {
  const url = `${API_URL}/master/orderstatus`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ orderStatusColor,orderStatusName,statusDescription},options);
}
export function createJobService(serviceType,serviceTypeDescription,price) {
  const url = `${API_URL}/master/jobservice`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ serviceType,serviceTypeDescription,price},options);
}
export function createImplant(implantName) {
  const url = `${API_URL}/master/implant`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ implantName},options);
}
export function editStatus(id,status) {
  const url = `${API_URL}/master/status/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,status,options);
}
export function editJobStatus(id,status) {
  const url = `${API_URL}/master/jobstatus/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,status,options);
}
export function editOrderStatus(id,status) {
  const url = `${API_URL}/master/orderstatus/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,status,options);
}
export function editJobService(id,service) {
  const url = `${API_URL}/master/jobservice/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,service,options);
}
export function editAccountStatus(status) {
  const url = `${API_URL}/master/accountstatus`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,status,options);
}

export function addNotes(id,notesObj,type) {
  let url='';
  if(type==='pentity')
    url = `${API_URL}/patient/notes/`+id;
  else
    url = `${API_URL}/schedule/notes/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,notesObj,options);
}

export function addJobNotes(id,notesObj) {
  
  let url = `${API_URL}/jobrequest/notes/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,notesObj,options);
}

export function addAttributes(id,attributesObj) {
  
  let url = `${API_URL}/jobrequest/servicetypes/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,attributesObj,options);
}

export function updateOrder(id,orderDetails) {
  
  let url = `${API_URL}/order/orderupdate/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,orderDetails,options);
}


export function deleteNotes(id) {
  
  let  url = `${API_URL}/patient/notes/delete/`+id;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{},options);
}



export function updateMyProfile(firstName, lastName, email, mobile,city,address,state,country,pincode) {
  const url = `${API_URL}/profile/update`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,{ firstName, lastName, email, mobile, city,address,state,country,pincode},options);
}

export function register(firstName, lastName, email, mobile, businessEntity,entityName,address,location,registrationNotes,organizationRole,status) {
  const options = {
  headers: {
    'Authorization': "Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}"
  }};
  return axios.post(REGISTER_URL, { firstName, lastName, email, mobile,  businessEntity,entityName,address,location,registrationNotes,organizationRole,status});
}

export function requestPassword(email) {
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(REQUEST_PASSWORD_URL,options, { email });
}

export function verifyOTP(otp,user) {
  //console.log(otp);
  //console.log(user);
  const url = `${API_URL}/registration/verify/`+otp;
  //console.log(url);
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.post(url,options, user);
}


export function getMaster(master)
{
  let url =''
  
  url = `${API_URL}/master/`+master+'?perPage=100';
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
 if(master==='pEntity')
  { 
   url = `${API_URL}/patient/list?page=1&sortBy=firstName`;
   return axios.post(url,{},options);
  }
  else if(master === 'account')
  {
    url = `${API_URL}/profile/accounts`;
    return axios.get(url,options);
  }
   else if(master === 'implant')
  {
    url = `${API_URL}/master/implant`+'?perPage=100&sortBy=implantName';
    return axios.get(url,options);
  }
  else if(master === 'status')
  {
    url = `${API_URL}/master/status`+'?perPage=100&sortBy=statusName';
    return axios.get(url,options);
  }
  else if(master === 'role')
  {
    url = `${API_URL}/master/role`+'?perPage=100&sortBy=roleDescription';
    return axios.get(url,options);
  }
  else if(master === 'tasktype')
  {
    url = `${API_URL}/master/tasktype`+'?perPage=100&sortBy=taskTypeName';
    return axios.get(url,options);
  }
  else if(master === 'jobservice')
    {
      url = `${API_URL}/master/tasktype`+'?perPage=100&sortBy=serviceType';
      return axios.get(url,options);
    }
  else if(master === 'entity')
  {
    url = `${API_URL}/master/entity`+'?perPage=100&sortBy=businessEntity';
    return axios.get(url,options);
  }
   else if(master === 'category')
  {
    url = `${API_URL}/master/category`+'?perPage=100&sortBy=_id';
    return axios.get(url,options);
  }
   else if(master === 'subcategory')
  {
    url = `${API_URL}/master/subcategory`+'?perPage=100&sortBy=_id';
    return axios.get(url,options);
  }
  else
    return axios.get(url,options);
}

export function getNotifications()
{
  let url =''
  
  url = `${API_URL}/profile/notification?page=1&perPage=20`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
 
   return axios.post(url,{},options);
}
export function getAudit()
{
  let url =''
  
  url = `${API_URL}/profile/audit?page=1`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
 
   return axios.post(url,{},options);
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  //return axios.get(ME_URL);
  /*
  const user = {
    id: 1,
    username: "admin",
    password: "demo",
    email: "admin@demo.com",
    accessToken: localStorage.getItem(TOKEN_PREFIX+'_access_token'),
    refreshToken: "access-token-f8c137a2c98743f48b643e71161d90aa",
    roles: [1], // Administrator
    role: "Portal Administrator",
    pic: toAbsoluteUrl("/media/users/300_25.jpg"),
    fullname: "Sean",
    occupation: "CEO",
    companyName: "Keenthemes",
    phone: "456669067890",
    address: {
      addressLine: "L-12-20 Vertex, Cybersquare",
      city: "San Francisco",
      state: "California",
      postCode: "45000"
    },
    socialNetworks: {
      linkedIn: "https://linkedin.com/admin",
      facebook: "https://facebook.com/admin",
      twitter: "https://twitter.com/admin",
      instagram: "https://instagram.com/admin"
    }
  };
  */
  //console.log(user);
  const url = `${API_URL}/profile/user`;
  const options = {
  headers: {
    'Authorization': `Bearer ${localStorage.getItem(TOKEN_PREFIX+'_access_token')}`
  }};
  return axios.get(url,options);

  //return [200, { ...user, password: undefined }];;
}

export function getUserByTokenAuth() {
  // Authorization head should be fulfilled in interceptor.
  //return axios.get(ME_URL);
  let user =null;
 // if(localStorage.getItem(TOKEN_PREFIX+'_access_token')!=null)
  //{
     user = {
      id: 1,
      username: "admin",
      password: "demo",
      email: "admin@demo.com",
      accessToken: localStorage.getItem(TOKEN_PREFIX+'_access_token'),
      refreshToken: "access-token-f8c137a2c98743f48b643e71161d90aa",
      roles: [1], // Administrator
      role: "Portal Administrator",
      pic: toAbsoluteUrl("/media/users/300_25.jpg"),
      fullname: "Sean",
      occupation: "CEO",
      companyName: "Keenthemes",
      phone: "456669067890",
      address: {
        addressLine: "L-12-20 Vertex, Cybersquare",
        city: "San Francisco",
        state: "California",
        postCode: "45000"
      },
      socialNetworks: {
        linkedIn: "https://linkedin.com/admin",
        facebook: "https://facebook.com/admin",
        twitter: "https://twitter.com/admin",
        instagram: "https://instagram.com/admin"
      }
    };
  //}

  
  //console.log("yser::::",user);
  return user;
}